import postRobot, { HandlerType } from 'post-robot';
import getParamFromUrl from 'common/get-param';
import { CommunicatorMessageType, VisaSdkMessageType } from 'types/messages/post-robot';

const parentUrl = getParamFromUrl(window.location.href, 'parentUrl');

export function listenToVisaSdk(name: VisaSdkMessageType, cb: HandlerType) {
  return postRobot.on(name, { domain: parentUrl, window: window.parent }, cb);
}

export function sendToVisaSdk(name: CommunicatorMessageType, data?: object) {
  postRobot.send(window.parent, name, data, {
    domain: parentUrl,
    timeout: 0
  });
}

export function postmessageToParent(message: Record<string, unknown>) {
  window.parent.postMessage(message, parentUrl);
}
